<template>
	<div v-show="isready" class="cpdf">
		<div class="center">
			<div class="contor">
                <div class="row " style="font-size: 15px" v-if="!$IsMobile">
                    <div class="col-sm-4 text-right">
                        <i class="fa fa-chevron-circle-left fa-2x" @click="prev"></i>
                        <i class="fa fa-chevron-circle-right fa-2x" @click="next"></i>
                        <i class="fa fa-download fa-2x" aria-hidden="true" @click="downloadpdf"></i>
                    </div>
                    <div class="col-sm-4">
                        <span style="color: #fff">Page: <span v-text="page_num"></span> / <span v-text="page_count"></span></span>
                    </div>
                    <div class="col-sm-4 text-left">
                        <i class="fa fa-plus-circle fa-2x" @click="addscale"></i>
                        <i class="fa fa-minus-circle fa-2x"  @click="minus"></i>
                        <i class="fa fa-times-circle fa-2x"  @click="closepdf"></i>
                    </div>
                
                </div>
                <div class="row " style="font-size: 13px" v-if="$IsMobile">
                    <i class="fa fa-chevron-circle-left fa-2x" @click="prev"></i>
                    <i class="fa fa-chevron-circle-right fa-2x" @click="next"></i>
                    <i class="fa fa-download fa-2x" aria-hidden="true" @click="downloadpdf"></i>
                    <span style="color: #fff; padding: 0px 17px"><span v-text="page_num"></span> / <span v-text="page_count"></span></span>
                    <i class="fa fa-plus-circle fa-2x" @click="addscale"></i>
                    <i class="fa fa-minus-circle fa-2x"  @click="minus"></i>
                    <i class="fa fa-times-circle fa-2x"  @click="closepdf"></i>
                </div>
			</div>
            <div class="row">
                <div class="col-sm-12">
                    <canvas class="canvasstyle" id="the-canvas"></canvas>
                </div>
            </div>
		</div>
	</div>
</template>
<script>
    import PDFJS from 'vue-pdfviewer/pdf/pdf';
    import Axios from 'axios'

    export default {
        name: 'c-pdf',
        props: {
            pdfurl: {
                default: '',
            },
            value: {

            },
            maxscale: {
                default: 1,
                type: Number
            },
            minscale: {
                default: 0.8,
                type: Number
            },
            scale: {
                default: null,
                type: Number
            },
            desiredWidth:null
        },
        //['pdfurl', 'value'],
        data() {

            return {
                pdfDoc: null, //pdfjs 生成的对象
                pageNum: 1, //
                pageRendering: false,
                pageNumPending: null,
                compuscale: 0, //放大倍数
                page_num: 0, //当前页数
                page_count: 0, //总页数
                // maxscale: 2, //最大放大倍数
                // minscale: 0.8, //最小放大倍数
                isready: false,
                statePdfUrl : '',
                loader : false
            }
        },
        methods: {
            downloadpdf() {
                 Axios({
                    url: this.statePdfUrl,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'labotistreport.pdf');
                    document.body.appendChild(link);
                    link.click();
                });
            },
            renderPage(num) { //渲染pdf
                let vm = this
                this.pageRendering = true;
                let canvas = document.getElementById('the-canvas')
                // Using promise to fetch the page
                this.pdfDoc.getPage(num).then(function(page) {
					if(vm.desiredWidth==null||vm.compuscale!=null){
                        var viewport = page.getViewport(vm.compuscale);
                        //alert(vm.canvas.height)
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;
                        vm.isready = true
                        var renderContext = {
                            canvasContext: vm.ctx,
                            viewport: viewport
                        };
					}else{
                        var desiredWidth = vm.desiredWidth;
                        var viewport = page.getViewport(1);
                        var scale = desiredWidth / viewport.width;
                        var scaledViewport = page.getViewport(scale);
                        canvas.height = scaledViewport.height;
                        canvas.width = scaledViewport.width;
                        vm.compuscale=scale;
                        vm.isready = true
                        var renderContext = {
                            canvasContext: vm.ctx,
                            viewport: scaledViewport
                        };
					}
                    // Render PDF page into canvas context

                    var renderTask = page.render(renderContext);

                    // Wait for rendering to finish
                    renderTask.promise.then(function() {
                        vm.pageRendering = false;
                        if (vm.pageNumPending !== null) {
                            // New page rendering is pending
                            vm.renderPage(vm.pageNumPending);
                            vm.pageNumPending = null;
                        }
                    });
                });
                vm.page_num = vm.pageNum;

            },
            addscale() {
                if (this.compuscale >= this.maxscale) {
                    return
                }
                this.compuscale += 0.1;
                this.queueRenderPage(this.pageNum)
            },
            minus() { 
                if (this.compuscale <= this.minscale) {
                    return
                }
                this.compuscale -= 0.1;
                this.queueRenderPage(this.pageNum)
            },
            prev() { //上一页
                let vm = this
                if (vm.pageNum <= 1) {
                    return;
                }
                vm.pageNum--;
                vm.queueRenderPage(vm.pageNum);
            },
            next() { //下一页
                let vm = this
                if (vm.pageNum >= vm.page_count) {
                    return;
                }
                vm.pageNum++;
                vm.queueRenderPage(vm.pageNum);
            },
            closepdf() { //关闭PDF
                this.pdfDoc = null;
                this.isready = false
                this.compuscale = this.scale
                this.$emit('closepdf')
            },
            throwerr(err) {
                this.$emit('pdferr', err);
            },
            queueRenderPage(num) {
                if (this.pageRendering) {
                    this.pageNumPending = num;
                } else {
                    this.renderPage(num);
                }
            }
        },
        computed: {
            ctx() {
                let id = document.getElementById('the-canvas')
                return id.getContext('2d');
            },
            isshowpdf() {
                if (this.value == undefined) return false
                return this.value;
            }
        },
        mounted() {
            this.compuscale = this.scale
        },
        watch: {
            isshowpdf(b) {
                let vm = this
                var val = vm.pdfurl
                this.statePdfUrl = val

                if (b == false || val == '' || val == undefined) return
                this.$showPageLoading()
                PDFJS.getDocument(val).then(function(pdfDoc_) { 
                    vm.pdfDoc = pdfDoc_;
                    vm.page_count = vm.pdfDoc.numPages
                    vm.renderPage(vm.pageNum);
                    this.$hidePageLoading()
                }.bind(this)).catch(function(err) {
                    if (err) {
                        console.log(err)
                        vm.throwerr(vm.pdfurl)
                        this.$hidePageLoading()
                    }
                }.bind(this))
            }


        }
    }
</script>

<style>
	.cpdf {
		position: fixed;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, .5);
		width: 100%;
		height: 100%;
		z-index: 99999;
		display: flex;
		justify-content: center;
		align-items: center;
	}
    .contor .fa {
        color: #fff;
        padding: 0px 10px;
    }

	.cpdf .btn {
		font-size: 12px;
		display: inline-block;
		line-height: 1;
		white-space: nowrap;
		cursor: pointer;
		background: #fff;
		border: 1px solid #bfcbd9;
		color: #1f2d3d;
		-webkit-appearance: none;
		text-align: center;
		box-sizing: border-box;
		outline: 0;
		margin: 0;
		padding: 8px 10px;
		border-radius: 4px;
	}

	.cpdf .center {
		text-align: center;
		height: 100%;
		overflow: auto;
		padding-top: 0px;
        width:100%;
        background: rgba(0, 0, 0, 0.45)
	}

	.cpdf .center .contor {
		margin-bottom: 10px;
        padding: 15px;
    background: #000;
	}

</style>


// WEBPACK FOOTER //
// src/components/plugin/vue-pdfviewer/CPdf.vue